import controller from './edit.controller';
import template from './edit.html';

const editCategoryComponent = {
  restrict: 'E',
  bindings: {
    mode: '@',
    parent: '=?',
    onCancel: '&'
  },
  controller,
  template
};

export default editCategoryComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/categories/edit/edit.component.js
 **/